import { render, staticRenderFns } from "./OptionsSvg.vue?vue&type=template&id=20aec15d&scoped=true&"
import script from "./OptionsSvg.vue?vue&type=script&lang=js&"
export * from "./OptionsSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aec15d",
  null
  
)

export default component.exports